import { getElements } from '../utils/functional'
import Flickity from 'flickity'

export default class ModalCarousel {
  constructor (el) {
    this.els = {
      triggers: getElements('[data-slide]')
    }

    const flkty = new Flickity(el, {
      cellAlign: '0.3',
      contain: true,
      wrapAround: true,
      pageDots: false,
      draggable: false
    })

    this.els.triggers.forEach(trigger => {
      trigger.addEventListener('click', evt => {
        const index = trigger.getAttribute('data-slide')
        flkty.select(index)
      })
    })
  }
}
